import { gql } from "@apollo/client";

export default gql`
  fragment CollectionGroupCardFields on Group {
    _id
    viewerIsMember
    name
    slug
    logo
    createdAt
  }
`;
